import { useEffect, useRef, useState } from "react";
import { toast } from "sonner";
import { Upload } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";

export const CorrImport = ({ onDone }) => {
  const [on, setOn] = useState(false);
  const [busy, setBusy] = useState(false);
  const [res, setRes] = useState(null);
  const ref = useRef(null);
  useEffect(() => { api.get("/corrispettivi/stato").then((r) => setOn(!!r.data.importa)).catch(() => {}); }, []);
  if (!on) return null;
  const send = async (files) => {
    if (!files.length) return;
    const fd = new FormData();
    [...files].forEach((f) => fd.append("files", f));
    setBusy(true);
    try { const { data } = await api.post("/corrispettivi/import", fd); setRes(data); toast.success(`${data.importate} giornate importate`); onDone(); } catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
    ref.current.value = "";
  };
  return (
    <div className="rounded-xl border border-sky-200 bg-sky-50 p-4" data-testid="corr-import">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <span className="text-sm text-slate-700"><b>Importa corrispettivi trasmessi</b>: file XML (anche .p7m o ZIP) scaricati dal portale Fatture e Corrispettivi.</span>
        <input ref={ref} type="file" multiple accept=".xml,.p7m,.zip" className="hidden" data-testid="corr-import-input" onChange={(e) => send(e.target.files)} />
        <Button className="bg-sky-600 hover:bg-sky-700" disabled={busy} data-testid="corr-import-button" onClick={() => ref.current.click()}><Upload className="mr-2 h-4 w-4" />{busy ? "Importazione…" : "Importa file"}</Button>
      </div>
      {res && (
        <ul className="mt-3 space-y-1 text-xs" data-testid="corr-import-results">
          {res.risultati.map((r, i) => <li key={i} className={r.ok ? "text-emerald-700" : "text-rose-700"}>{r.data ? `${r.data.split("-").reverse().join("/")} · ` : ""}{r.file}: {r.ok ? "importata" : r.errore}</li>)}
        </ul>
      )}
    </div>
  );
};
